const SEEN_KEY = "wa_seen_notification_ids";
const MAX_SEEN_IDS = 200;

export function getNotificationId(item, index = 0) {
  return String(
    item?._id || item?.id || `${item?.title || "n"}:${item?.createdAt || index}`,
  );
}

export function readSeenNotificationIds() {
  try {
    const parsed = JSON.parse(localStorage.getItem(SEEN_KEY) || "[]");
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

export function countUnreadNotifications(list = []) {
  const seen = readSeenNotificationIds();
  return list.filter((item, index) => !seen.has(getNotificationId(item, index)))
    .length;
}

export function markNotificationsSeen(list = []) {
  const seen = readSeenNotificationIds();
  list.forEach((item, index) => seen.add(getNotificationId(item, index)));
  const ids = [...seen].slice(-MAX_SEEN_IDS);
  localStorage.setItem(SEEN_KEY, JSON.stringify(ids));
  return 0;
}
